// auth/auth.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { Logger } from 'shared';

export const authGuard: CanActivateFn = (route, state) => {
  const authService: AuthService = inject(AuthService);
  const router: Router = inject(Router);
  const logger = new Logger('authGuard: CanActivateFn');
  return authService.isLoggedIn$().pipe(
    take(1),
    map(isLoggedIn => {
      if (isLoggedIn) {
        logger.debug(`LOGGED IN => CAN ACTIVATE: ${route.url}`);
        return true;
      }
      logger.debug(`NOT LOGGED IN => CANNOT ACTIVATE: ${route.url}. PERFORM NAVIGATION TO /login`);
      router.navigate(['/login']);
      return false;
    })
  );
};